var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPennyLogo1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 111.964,
    height: 40.964,
    viewBox: "0 0 111.964 40.964",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3442",
    width: 40.964,
    height: 40.964,
    fill: "#1b5568"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8343",
    transform: "translate(-1226 -24.518)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "Ask_Penny",
    transform: "translate(1283 42)",
    fill: "#1b5568",
    fontSize: 14,
    fontFamily: "Roboto-Black, Roboto",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -24,
    y: 0
  }, "Ask"), /*#__PURE__*/React.createElement("tspan", {
    fontSize: 21,
    fontFamily: "Roboto-Light, Roboto",
    fontWeight: 300
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -56,
    y: 17
  }, "Penny"))), /*#__PURE__*/React.createElement("g", {
    id: "Group_8332",
    transform: "translate(1297 24.518)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8332-2",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5714",
    d: "M60.424,57.471a4.738,4.738,0,0,0,2.3,3.911,2.376,2.376,0,0,1,.026.347A2.464,2.464,0,0,1,61.2,63.721v.326a6.038,6.038,0,0,0,4.455-1.6,7.68,7.68,0,0,0,.964.061c3.421,0,6.194-2.253,6.194-5.033s-2.773-5.032-6.193-5.032-6.193,2.253-6.193,5.032",
    transform: "translate(-43.344 -37.616)",
    fill: "#1b5568"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5715",
    d: "M20.482,0A20.483,20.483,0,0,0,10.8,38.535V11.8a1.736,1.736,0,0,1,1.921-1.921H24.432c6.494,0,10.153,4.848,10.153,10.473,0,5.58-3.7,10.107-10.153,10.107H16.84v9.513a2.631,2.631,0,0,1-.077.653A20.481,20.481,0,1,0,20.482,0",
    fill: "#1b5568"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPennyLogo1);
export default __webpack_public_path__ + "static/media/penny_logo_1.9b1d40849b51db0aff06c8ba72f4c696.svg";
export { ForwardRef as ReactComponent };